import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Susuras en vento Malnova Afiŝo, delogante la publikon:
    </p>
    
    <p class="mb-3">
      venu, rigardu min! 
      Mi ankoraŭ  estas helkolora, mi bone konserviĝis!
    </p>
    
    <p class="mb-3">
      lirtas, dancas en la vento, sed oni preteriras, ne atentante ŝin.
    </p>
    
    <p class="mb-3">
      azos tre interesa koncerto, - tente flustras ŝi. 
      – Gaja koncerto, plej bonaj artistoj partoprenos…
    </p>
    
    <p class="mb-3">
      kas ŝi, promesas. 
      Sed tute ne povas kompreni, ke ŝia koncerto jam delonge pasis kaj neniam plu okazos.
    </p>
    `
  )
}

const itemName = {
  esp: 'Malnova afiŝo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;